var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 356.39,
    viewBox: "135.5 361.38 1e3 356.39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 245.8075,717.62406 c -29.79588,-1.1837 -54.1734,-9.3368 -73.23459,-24.4796 -3.63775,-2.8928 -12.30611,-11.5663 -15.21427,-15.2245 -7.72958,-9.7193 -12.98467,-19.1785 -16.48977,-29.6734 -10.7857,-32.3061 -5.23469,-74.6989 15.87753,-121.2243 18.0765,-39.8316 45.96932,-79.3366 94.63252,-134.0508 7.16836,-8.0511 28.51526,-31.5969 28.65302,-31.5969 0.051,0 -1.11225,2.0153 -2.57652,4.4694 -12.65304,21.1938 -23.47957,46.158 -29.37751,67.7703 -9.47448,34.6785 -8.33163,64.4387 3.34693,87.5151 8.05611,15.898 21.86731,29.6684 37.3979,37.2806 27.18874,13.3214 66.9948,14.4235 115.60699,3.2245 3.34694,-0.7755 169.19363,-44.801 368.55048,-97.8366 199.35686,-53.0408 362.49439,-96.4029 362.51989,-96.3672 0.056,0.046 -463.16259,198.2599 -703.62654,301.0914 -38.08158,16.2806 -48.26521,20.3928 -66.16827,26.6785 -45.76525,16.0714 -86.76008,23.7398 -119.89779,22.4235 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNike);
export default __webpack_public_path__ + "static/media/nike.16c9e044b7bdca9fa207556b53fa5c15.svg";
export { ForwardRef as ReactComponent };